import { put, call, takeLatest, select } from 'redux-saga/effects';

import { formatError } from '../../../libs';
import customerAPI from '../../api/customer';
import { Types, Creators } from '../../reducers/customer';
import getState from '../../utils/getState';

function* customerDocsEnumRequest() {
  try {
    const { app } = yield select(getState);
    const siteId = app.getIn(['config', 'siteId']);

    const data = yield call(customerAPI.docsEnum, siteId);

    yield put(Creators.customerDocsEnumSuccess(data));
  } catch (error) {
    yield put(Creators.customerDocsEnumFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CUSTOMER_DOCS_ENUM_REQUEST, customerDocsEnumRequest);
}
